module.exports = __webpack_public_path__ + "static/media/BoxPlotQ5_4.8460845f.svg";